import { generateContentFromTrend, generateManualContent } from './methods/generate-content'
import { saveContent, publishContent } from './methods/save-content'

/**
 * Content actions for API communication
 */
export const contentActions = {
  generateContentFromTrend,
  generateManualContent,
  saveContent,
  publishContent
}

export {
  generateContentFromTrend,
  generateManualContent,
  saveContent,
  publishContent
}
